import { Injectable } from '@angular/core'
import { IdentityService } from 'main/services/identity.service'
import { APIService } from 'api/module'
import { Asset, AssetRating } from 'elements-sdk'

@Injectable({ providedIn: 'root' })
export class MediaAssetRatingsService {
  constructor (
    private api: APIService,
    private identity: IdentityService,
  ) { }

  get (asset: Asset): Promise<AssetRating[]> {
    return this.api.mediaLibrary.getAllAssetRatings({
      asset: asset.id,
    })
  }

  async rate (
    asset: Asset,
    rootId: number,
    rating: number,
  ): Promise<Asset> {
    if (!this.identity.user) {
      return asset
    }

    if (rating) {
      await this.api.mediaLibrary.createAssetRating({
        assetRatingUpdate: {
          user: this.identity.user,
          asset: asset.id,
          rating,
        },
        root: rootId,
      })
    } else {
      const ratings = await this.api.mediaLibrary.getAllAssetRatings({
        asset: asset.id,
        user: this.identity.user.id,
      })
      for (const item of ratings) {
        if (!item.id) {
          continue
        }
        await this.api.mediaLibrary.deleteAssetRating({
          id: item.id,
          root: rootId,
        })
      }
    }

    return this.api.mediaLibrary.getAsset({ id: asset.id })
  }

  getColorClass (rating: number): string {
    return `rating-color-${Math.ceil(rating)}`
  }
}
